<script lang="ts">
    interface Props {
        position: number
    }

    let {
        position
    }: Props = $props()
</script>

<div class="cta-divider">
    {#if position === 1}
        <h3>🔍&nbsp;Curious about more German words?</h3>
        <p>This is just the start — these words are part of a much bigger picture. Dive into <b>vocabeo</b>'s full
            frequency-based
            dictionary and discover where these words rank among the most-used German vocabulary.</p>
        <a href="/browse" class="button-primary">Browse »</a>
    {:else if position === 2}
        <h3>😓&nbsp;Struggling to remember these words?</h3>
        <p>Stay on top of your vocabulary with <b>vocabeo</b>’s smart spaced repetition flashcards — designed to make
            words stick for good.</p>
        <a href="/learn" class="button-primary">Learn »</a>
    {:else if position === 3}
        <h3>🇩🇪&nbsp;More German Awaits</h3>
        <p>You've seen a glimpse! These words are just the beginning. Explore <b>vocabeo</b>'s comprehensive,
            frequency-ranked
            dictionary to see where they fit in the most common German vocabulary.</p>
        <a href="/browse" class="button-primary">Browse »</a>
    {:else if position === 4}
        <h3>🚀&nbsp; You've made it this far — ready to level up?</h3>
        <p>Forget forgetting! Practice smarter with <b>vocabeo</b>'s spaced repetition flashcards and make German
            vocabulary stick.</p>
        <a href="/learn" class="button-primary">Learn »</a>
    {/if}
</div>

<style>
    .cta-divider {
        display: grid;
        justify-items: flex-start;
        padding: 1.4rem 2rem;
        border: 4px solid var(--color-Verb);
        border-radius: var(--border-radius);
    }

    h3 {
        margin: 0;
    }

    p {
        margin-block: .4rem .8rem;
    }

    a {
        color: var(--text-on-color) !important;
        font-size: 1rem !important;
    }
</style>